import AdminOnly from '@maxpreps/shared/corecomponents/AdminOnly/AdminOnly';
import React from 'react';
import { IClientContest } from '../../../utils/schedule/serializeSchedule';
import ContestDetailsList from './ContestDetailsList';
import ContestSummary from './ContestSummary';

interface IScheduleMainCellProps {
  contest: IClientContest;
}

const ScheduleMainCell: React.FC<IScheduleMainCellProps> = ({ contest }) => (
  <td>
    <ContestSummary contest={contest} />
    <AdminOnly>
      <ContestDetailsList contest={contest} />
    </AdminOnly>
  </td>
);

export default ScheduleMainCell;
